import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

// css
import styles from "./ContentPagePop.module.scss";
import Select from "react-select";
import { Controller, useForm } from "react-hook-form";
import {
  useAddContentPageMutation,
  useUpdateContentPageMutation,
} from "../../../store/services/contentPagesServices";
import toast from "react-hot-toast";
//import CKEditorField from "../../ckEditor/CKEditorField";
import CKEditorNew from "../../newCkEditor/ckEditor";
import Dropzone from "../../Dropzone/Dropzone";

const Names = [
  // { value: "ABOUT_US", label: "About us" },
  { value: "BLOG", label: "BLOG" },
  { value: "PRIVACY_POLICY", label: "Privacy policy" },
  { value: "TERMS_CONDITIONS", label: "Terms conditions" },
  { value: "CONTACT_US", label: "Contact us" },
  { value: "COOKIE_POLICY", label: "Cookie policy" },
  // { value: "SUSTAINABILITY", label: "Sustainability" },
  // {
  //   value: "PARTNERSHIPS_AND_AFFILIATES_PROGRAM",
  //   label: "Partnerships and affiliates program",
  // },
];

const ContentPagePop = ({ title, modalOpen, setModalOpen, edit }) => {
  const {
    control,
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onTouched", // Validation mode set to 'onTouched'
    defaultValues: {
      name: edit?.name,
      status: edit?.status,
      content: edit?.content,
      pageTitle: edit?.pageTitle,
      secondTitle: edit?.secondTitle,
      desc: edit?.desc,
      image: edit?.image,
    },
  });

 

  const [selectedContentPages, setSelectedContentPages] = useState(
    edit?.name ? Names.find((option) => edit.name.includes(option.value)) : null
  );
  const [addContentPage, { isLoading: isAdding }] = useAddContentPageMutation();
  const [updateContentPage, { isLoading: isUpdating }] =
    useUpdateContentPageMutation();

  // Handler for react-select
  const handleContentPageChange = (selectedOptions) => {
    setSelectedContentPages(selectedOptions || []);
    const value = selectedOptions.value || null;
    setValue("name", value); // Update react-hook-form state with an array of values
  };

  // Submit handler
  const onSubmit = async (data) => {
    try {
      if (edit !== null) {
        // Update existing meals
        await updateContentPage({
          ingredientId: edit._id,
          updatedData: data,
        });
      } else {
        await addContentPage(data).unwrap(); // Call deleteContentPage and handle success
      }
      setModalOpen(false);
      return toast.success(
        `Content page ${edit ? "updated" : "added"} successfully`
      );
    } catch (error) {
      console.error("Failed to delete the meal:", error); // Handle error
    }
  };

  const hideHandler = () => {
    setModalOpen(false);
  };
  return (
    <Modal
      show={modalOpen}
      className={`${styles.ContentPagePop} transparentModal`}
      onHide={hideHandler}
      backdrop={true}
      keyboard={false}
      centered
      size="lg"
      enforceFocus={false}
    >
      <Modal.Body className={`${styles.modalBody}`}>
        <div className="mx-auto">
          <h3 className="m-0 fw-bold themeBlue">{title}</h3>
          <Col lg="12" className="my-2">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col lg="12" md="12" className="my-2">
                  {/* Name Field */}
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Name
                    </label>
                    <Controller
                      name="name"
                      control={control}
                      rules={{
                        required: "Please select a name", // Validation rule
                      }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={Names}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          value={selectedContentPages}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption.value); // Update react-hook-form state
                            setSelectedContentPages(selectedOption); // Update local state
                          }}
                          placeholder="Select Name"
                        />
                      )}
                    />
                    {errors.name && (
                      <span className="text-danger">{errors.name.message}</span>
                    )}

                    {/* <Select
                      name="name"
                      options={Names}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      value={selectedContentPages}
                      onChange={handleContentPageChange}
                      placeholder="Select Name"
                      {...register("name", {
                        required: "Please enter name",
                      })}
                    />
                    {errors?.name && (
                      <span className="text-danger">{errors?.name?.message}</span>
                    )} */}
                  </div>
                </Col>

                <Col lg="12" md="12" className="my-2">
                  {/* Name Field */}
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Title
                    </label>
                    <input
                      type="text"
                      placeholder="Enter title"
                      name="pageTitle"
                      {...register("pageTitle", {
                        required: "Please enter title",
                        validate: (value) => {
                          if (/^\s/.test(value)) {
                            return "Title cannot start with a space";
                          }
                          // if (/[^a-zA-Z0-9\s]/.test(value)) {
                          //   return "Page title cannot include special characters or emojis";
                          // }
                          return true;
                        },
                      })}
                      className="form-control"
                    />
                    {errors.pageTitle && (
                      <span className="text-danger">{errors.pageTitle.message}</span>
                    )}
                  </div>
                </Col>

                <Col lg="12" md="12" className="my-2">
                  {/* Name Field */}
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Sub title
                    </label>
                    <input
                      type="text"
                      placeholder="Enter sub title"
                      name="desc"
                      {...register("desc", {
                        required: "Please enter sub title",
                        validate: (value) => {
                          if (/^\s/.test(value)) {
                            return "Sub title cannot start with a space";
                          }
                          // if (/[^a-zA-Z0-9\s]/.test(value)) {
                          //   return "Second title cannot include special characters or emojis";
                          // }
                          return true;
                        },
                      })}
                      className="form-control"
                    />
                    {errors.desc && (
                      <span className="text-danger">{errors.desc.message}</span>
                    )}
                  </div>
                </Col>

                {/* <Col lg="12" md="12" className="my-2">
                 
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      First section heading
                    </label>
                    <input
                      type="text"
                      placeholder="Enter heading"
                      name="secondTitle"
                      {...register("secondTitle", {
                        required: "Please enter first section heading",
                        validate: (value) => {
                          if (/^\s/.test(value)) {
                            return "first section heading title cannot start with a space";
                          }
                          if (/[^a-zA-Z0-9\s]/.test(value)) {
                            return "desc title cannot include special characters or emojis";
                          }
                          return true;
                        },
                      })}
                      className="form-control"
                    />
                    {errors.secondTitle && (
                      <span className="text-danger">{errors.secondTitle.message}</span>
                    )}
                  </div>
                </Col> */}

                <Col lg="12" md="12" className="my-2">
                  {/* Description Field */}
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Content image
                    </label>

                    <Controller
                      name="image"
                      control={control}
                      rules={{ required: "Please enter content image" }}
                      render={({ field }) => (
                        <Dropzone
                          field="image"
                          setFieldValue={setValue}
                          value={field.value}
                          error={errors}
                        />
                      )}
                    />
                    {errors.image && (
                      <span className="text-danger">
                        {errors.image.message}
                      </span>
                    )}
                  </div>
                </Col>


                {/* <Col lg="12" md="12" className="my-2">
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Content
                    </label>

                    <Controller
                      name="content"
                      control={control}
                      rules={{ required: "Please enter content" }}
                      render={({ field }) => (
                        <CKEditorField
                          field="content"
                          setFieldValue={setValue}
                          value={field.value}
                          error={errors}
                          placeholder="Type your content here..."
                        />
                      )}
                    />
                    {errors.content && (
                      <span className="text-danger">
                        {errors.content.message}
                      </span>
                    )}
                  </div>
                </Col> */}

                <Col lg="12" md="12" className="my-2">
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Content
                    </label>

                    <Controller
                      name="content"
                      control={control}
                      rules={{ required: "Please enter content" }}
                      render={({ field }) => (
                        <CKEditorNew
                          field="content"
                          setFieldValue={setValue}
                          value={field.value}
                          error={errors}
                          placeholder="Type your content here..."
                        />
                      )}
                    />
                    {errors.content && (
                      <span className="text-danger">
                        {errors.content.message}
                      </span>
                    )}
                  </div>
                </Col>

                <Col lg="6" md="6" className="my-2">
                  {/* Status Field */}
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Status
                    </label>
                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-start gap-10 ps-2 flex-wrap">
                      <li className="d-flex align-items-center">
                        <input
                          type="radio"
                          value="active"
                          {...register("status", {
                            required: "One radio button should appear selected",
                          })}
                          className="form-check"
                        />
                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                          Active
                        </label>
                      </li>
                      <li className="d-flex align-items-center">
                        <input
                          type="radio"
                          value="inactive"
                          {...register("status", {
                            required: "One Radio button should appear selected",
                          })}
                          className="form-check"
                        />
                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                          Inactive
                        </label>
                      </li>
                    </ul>
                    {errors.status && (
                      <span className="text-danger">
                        {errors.status.message}
                      </span>
                    )}
                  </div>
                </Col>
              </Row>

              {/* Submit & Cancel Buttons */}
              <Col lg="12" className="my-2">
                <div className="d-flex align-items-center justify-content-center gap-10">
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn"
                    type="submit"
                    disabled={isAdding || isUpdating}
                  >
                    Submit
                  </Button>
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
                    type="button"
                    onClick={() => {
                      setModalOpen(false);
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </Col>
            </Form>
          </Col>

          {/* <div className="btnWrpper mt-4 d-flex align-items-center justify-content-center gap-10">
            <div className="px-2 w-100">
              <Button
                onClick={hideHandler}
                className="fw-sbold d-flex align-items-center justify-content-center commonBtn w-100 GreyBtn"
              >
                Cancel
              </Button>
            </div>
            <div className="px-2 w-100">
              <Button
                onClick={confirmHandler}
                className="fw-sbold d-flex align-items-center justify-content-center commonBtn w-100"
              >
                {title}
              </Button>
            </div>
          </div> */}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ContentPagePop;
